<template>
  <div v-if="formattedRate.value !== 0" class="rate">
    <div class="rate_title">{{ getRateTitleText() }}</div>
    <div class="rate_row">
      <div class="rate_value">
        {{ formattedRate.value }}
      </div>
      <BaseSvgIcon name="chart" class="chart" viewBox="0 0 80 40" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { BaseSvgIcon } from "@/shared/ui";
import { comma } from "@/shared/utils/format";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { capitalizeFirstLetter } from "@/shared/utils/format/date";
import "@/assets/icons/SVG/chart.svg";

defineOptions({ name: "Rate" });

const store = useStore();
const route = useRoute();
const { t, locale } = useI18n();

const ratePairs = computed(() => store.state.coinService.ratePairs);

const network = computed(() => route.params.network);

function getRateTitleText() {
  if (locale.value === "ru") {
    return `${capitalizeFirstLetter(t("price"))} ${formattedRate.value.symbol}`;
  } else {
    return `${formattedRate.value.symbol} ${t("price")}`;
  }
}

const formattedRate = computed(() => {
  switch (network.value) {
    case "bitcoin":
      return {
        value: "$\u202F" + comma(ratePairs.value["btc_usd"]) || 0,
        symbol: "BTC",
      };
    case "tron":
      return {
        value: "$\u202F" + comma(ratePairs.value["trx_usd"]) || 0,
        symbol: "TRX",
      };
    case "usdt":
      return {
        value: "$\u202F" + comma(ratePairs.value["usdt_usd"]) || 0,
        symbol: "USDT",
      };
    case "ton":
      return {
        value: "$\u202F" + comma(ratePairs.value["ton_usd"]) || 0,
        symbol: "TON",
      };
    case "ethereum":
      return {
        value: "$\u202F" + comma(ratePairs.value["eth_usd"]) || 0,
        symbol: "ETH",
      };
    default:
      return {
        value: 0,
        symbol: "",
      };
  }
});
</script>

<style lang="scss" scoped>
.rate {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  background: var(--Dark-900, #111);
  padding: 24px 32px;

  @media (width < 768px) {
    padding: 20px 24px;
  }

  &_title {
    color: #7a7a7a;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 4px;
  }

  &_row {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    svg {
      position: absolute;
      right: 0;
      width: 80px;
      height: 40px;
    }
  }

  &_value {
    color: #fafafa;
    text-overflow: ellipsis;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
  }
}
</style>
